import {withPageBase} from "../../components/PageBase";
import {connect} from "react-redux";
import {selectUpcomingAndPastEvents} from "../timeline/data/selector";
import React, {createContext, useEffect} from "react";
import {TimelineFrameHeader} from "./components/header/TimelineFrameHeader";
import {TimelineFrameContent} from "./components/TimelineFrameContent";
import TimelineRescheduleTransitionModal from "../timeline/components/TimelineRescheduleTransitionModal";
import {TIMELINE, TIMELINEFRAME} from "../../data/reducer";
import Loader from "../../components/Loader";
import {isEmpty} from "lodash";
import Alert from "../../components/Alert";
import {clearNavigateToTimelineFrame} from "./data/actions";
import {linkkipalveluSelector} from "../../data/selector";


const { id: module_id } = module;
export const TimelineFrameDataContext = createContext(null);
const TimelineFramePage = ({
                               match, upcomingEvents, pastEvents,
                               showRescheduleTransitionModalForNotification,
                               isFetching, clearNavigateToTimelineFrame,
                               navigateFromTimeline, linkkipalvelu, genericPhrases
                           }) => {

    useEffect(() => {
        if (navigateFromTimeline) {
            clearNavigateToTimelineFrame();
        }
    }, [navigateFromTimeline]);


    // Show loader if application hasn't initialized timeline data.
    // UpcomingEvents and PastEvents have empty arrays as initial data
    if(isEmpty(upcomingEvents) && isEmpty(pastEvents) && isFetching) return <Loader />;

    // Data id is string, match.params.id is number, using coercion.
    const data = [...upcomingEvents, ...pastEvents].find(e =>  e.id == match.params.id);

    // Fallback view for TimelineItem with id not present in data
    // This should only occur if user manually types id in url
    if(!data) {
        return (
            <div className="timeline-frame-error-container">
                <Alert message={'default.error.message'}/>
            </div>
        );
    }

    // Check if past, used for VideoConference render logic
    const past = pastEvents.includes(data);

    return (
      <>
          <TimelineFrameDataContext.Provider value={{data, past, linkkipalvelu, genericPhrases}}>
              <TimelineFrameHeader />
              <TimelineFrameContent />
              <TimelineRescheduleTransitionModal
                  isOpen={showRescheduleTransitionModalForNotification !== false}
                  notificationId={showRescheduleTransitionModalForNotification}
              />
          </TimelineFrameDataContext.Provider>
      </>
    );
}
const mapStateToProps = (state) => {
    let {
        upcomingEvents,
        pastEvents,
    } = selectUpcomingAndPastEvents(state);

    let {
        showRescheduleTransitionModalForNotification,
        isFetching,
    } = state[TIMELINE];

    let {
        timelineEventId,
        genericPhrases
    } = state[TIMELINEFRAME]

    let linkkipalvelu = linkkipalveluSelector(state);

    return {
        upcomingEvents: upcomingEvents,
        pastEvents: pastEvents,
        showRescheduleTransitionModalForNotification:
            showRescheduleTransitionModalForNotification,
        isFetching: isFetching,
        navigateFromTimeline: timelineEventId,
        genericPhrases: genericPhrases,
        linkkipalvelu: linkkipalvelu
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearNavigateToTimelineFrame: () =>
            dispatch(clearNavigateToTimelineFrame()),
    };
}

export default withPageBase(
    connect(mapStateToProps, mapDispatchToProps)(TimelineFramePage),
    {
        title: `${module_id}.title`,
        showTitle: false,
        type: 'timeline-item-page',
    });